module.exports = __webpack_public_path__ + "static/media/ico-delete.9518977b.svg";